import type { SupportedLocale } from "@shared/host/host-context";
import { apiClient } from "../lib/api-client";

interface UpdateLocaleResponse {
  locale: SupportedLocale;
}

export const updateMyLocalePreference = async (
  locale: SupportedLocale,
): Promise<UpdateLocaleResponse> => {
  const { data } = await apiClient.patch<UpdateLocaleResponse>(
    "/users/me/locale",
    { locale },
  );

  return data;
};
